import styled from "styled-components"

export default styled.p`
  color: red;
  margin-bottom: 0.75rem;
`
